/*
 * Product · Quiz CTA video (sections/pdp-quiz-cta.liquid).
 * Replo autoplays the muted, looping video. Here it starts when it comes on
 * screen and pauses when it leaves, so the MP4 is not downloaded with the page.
 * Visitors who prefer reduced motion keep the poster.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function play(video) {
    if (reduce && reduce.matches) return;
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function init(video) {
    if (!video || video.pdpQuizInit) return;
    video.pdpQuizInit = true;
    video.muted = true;

    if (!('IntersectionObserver' in window)) {
      play(video);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    io.observe(video);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdp-quiz-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
